import { ACTIONS_MACHINE_MINE_PLAN } from '_constants/machineMinePlan.constants';

const initialState = {
  byId: {},
};

export function machineMinePlanReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_MACHINE_MINE_PLAN.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_MACHINE_MINE_PLAN.DELETE: {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_MACHINE_MINE_PLAN.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default machineMinePlanReducer;
